module.exports = __webpack_public_path__ + "media/images/meta/clubpilates_aus/apple-touch-icon-28e37c0b57e0c8ff15d38e5c03eda070.png";